

export function addUrlParam(url, key, value) {
  const newUrl = new URL(url);
  newUrl.searchParams.append(key, value);
  return newUrl.toString();
}
